/**
 * НАЗНАЧЕНИЕ: Точка входа React приложения
 * ОПИСАНИЕ: Инициализирует React приложение с необходимыми провайдерами:
 * - Redux Provider - глобальное состояние приложения
 * - GlobalUploadProvider - контекст для глобального виджета загрузки файлов
 * СТРУКТУРА: App является корневым компонентом со всей маршрутизацией
 * ПРОИЗВОДИТЕЛЬНОСТЬ: Включает reportWebVitals для мониторинга
 */
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import "./index.css";
import App from "components/App";
import reportWebVitals from "./reportWebVitals";
import { store } from "shared/model/store";
import { GlobalUploadProvider } from "pages/UploadSlide/lib/GlobalUploadContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <GlobalUploadProvider>
            <App />
        </GlobalUploadProvider>
    </Provider>
);

reportWebVitals();
